import {createSelector} from "reselect"
import {connect} from "react-redux"
import State from "../../ducks/state"
import urls from "../../config/urls"

const textSelector = createSelector(
    (state: State) => state.text,
    text => ({miniShoppingBag: text.miniShoppingBag, shoppingBag: text.shoppingBag}),
)

export const mapStateToProps = (state: State) => ({
    text: textSelector(state),
    itemCount: state.shoppingBag.itemCount,
    checkoutUrl: `${state.request.siteUrl}${urls.shoppingBag.url}`,
})

export default connect(mapStateToProps)
